import React, { useEffect, useState } from 'react';
import AppWebReportStundenTaetigkeiten from "./AppWebReportStundenTaetigkeiten";
import AppWebReportStundenVerortung from "./AppWebReportStundenVerortung";


function AppWebReportTaetigkeitVerortung({ type, stundenReportData, setStundenReportData}) {
    const [data, setData] = useState([]);
    useEffect(() => {
        // alert(type)
        if (type === 'Stunden-Anmeldung' && stundenReportData?.taetigkeit_angemeldet !== undefined) {
            setData(stundenReportData.taetigkeit_angemeldet);
        } else if (type === 'Stunden-Abmeldung' && stundenReportData?.taetigkeit_abgemeldet !== undefined) {
            setData(stundenReportData.taetigkeit_abgemeldet);
        }
    }, [stundenReportData]);

    return (
        <div
            style={{
                // backgroundColor: 'pink',
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: '50vh',
                justifyContent:'space-between'
            }}
        >
            {data.map((d) => {
                return (
                    <div style={{
                        display:'flex',
                        flexDirection:'row',
                        width:'100%',
                        justifyContent:'space-between',
                        alignItems:'flex-start',
                     }} key={d.id}>
                        <div
                            style={{
                                width: '28%',
                                height: 'auto',
                                marginRight:10,
                            }}
                        >
                            <AppWebReportStundenVerortung
                                stundenReportData={stundenReportData}
                                setStundenReportData={setStundenReportData}
                                verortungData={d.verortung}
                            />
                        </div>
                        <div
                            style={{
                                width: '72%',
                                height: 'auto'
                            }}
                        >
                            <AppWebReportStundenTaetigkeiten
                                stundenReportData={stundenReportData}
                                setStundenReportData={setStundenReportData}
                                taetigkeitenData={[d]}/>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default AppWebReportTaetigkeitVerortung;
